import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/addCalendar.svg';
const AddCalendarSvg = () => React.createElement(IconSvg, null);
export default AddCalendarSvg;
